// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".span[data-v-7d8dfbc7] {\n  font-size: 14px;\n  cursor: text;\n}", ""]);
// Exports
module.exports = exports;
